// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.NewsEdit_card__9WW24 {
  background: var(--card);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(13, 38, 63, 0.06);
  padding: 16px;
}

.NewsEdit_grid__uv1f4 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.NewsEdit_input__UBKjH, .NewsEdit_textarea__n7LJu, .NewsEdit_date__SQILl {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9dfe8;
  border-radius: 10px;
  background: #fff;
}

.NewsEdit_actions__lUw8L {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 12px;
}

.NewsEdit_btn__ZK06j {
  background: #0d263f;
  color: #fff;
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
}
.NewsEdit_btn__ZK06j.NewsEdit_ghost__dPAAI {
  background: transparent;
  color: #0d263f;
  border: 1px solid #0d263f;
}

/* CKEditor обёртка, чтобы набор кнопок не упирался в края */
.NewsEdit_ckWrap__\\+p9\\+6 .ck-editor__editable_inline {
  min-height: 800px;
  border-radius: 10px !important;
}

/* NewsEdit.module.scss */
.NewsEdit_ckWrap__\\+p9\\+6 .tox-tinymce {
  height: auto !important;
  min-height: 800px !important; /* твоя минимальная */
}

.NewsEdit_ckWrap__\\+p9\\+6 .tox-edit-area__iframe {
  min-height: 760px !important; /* чуть меньше, чтобы учесть тулбар */
}`, "",{"version":3,"sources":["webpack://./src/modules/news/NewsEdit.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAEF;;AACA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAEF;AAAE;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AAEJ;;AAEA,4DAAA;AACA;EACE,iBAAA;EACA,8BAAA;AACF;;AACA,yBAAA;AACA;EACE,uBAAA;EACA,4BAAA,EAAA,qBAAA;AAEF;;AAAA;EACE,4BAAA,EAAA,qCAAA;AAGF","sourcesContent":[".card {\r\n  background: var(--card);\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 30px rgba(13, 38, 63, .06);\r\n  padding: 16px;\r\n}\r\n\r\n.grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 12px;\r\n}\r\n\r\n.input, .textarea, .date {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid #d9dfe8;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n}\r\n\r\n.actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  margin-top: 12px;\r\n}\r\n\r\n.btn {\r\n  background: #0d263f;\r\n  color: #fff;\r\n  border: 0;\r\n  border-radius: 10px;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n\r\n  &.ghost {\r\n    background: transparent;\r\n    color: #0d263f;\r\n    border: 1px solid #0d263f;\r\n  }\r\n}\r\n\r\n/* CKEditor обёртка, чтобы набор кнопок не упирался в края */\r\n.ckWrap :global(.ck-editor__editable_inline) {\r\n  min-height: 800px;\r\n  border-radius: 10px !important;\r\n}\r\n/* NewsEdit.module.scss */\r\n.ckWrap :global(.tox-tinymce) {\r\n  height: auto !important;\r\n  min-height: 800px !important;   /* твоя минимальная */\r\n}\r\n.ckWrap :global(.tox-edit-area__iframe) {\r\n  min-height: 760px !important;   /* чуть меньше, чтобы учесть тулбар */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `NewsEdit_card__9WW24`,
	"grid": `NewsEdit_grid__uv1f4`,
	"input": `NewsEdit_input__UBKjH`,
	"textarea": `NewsEdit_textarea__n7LJu`,
	"date": `NewsEdit_date__SQILl`,
	"actions": `NewsEdit_actions__lUw8L`,
	"btn": `NewsEdit_btn__ZK06j`,
	"ghost": `NewsEdit_ghost__dPAAI`,
	"ckWrap": `NewsEdit_ckWrap__+p9+6`
};
export default ___CSS_LOADER_EXPORT___;
